import { render, staticRenderFns } from "./intantTaskDetail.vue?vue&type=template&id=b4a87ef4"
import script from "./intantTaskDetail.vue?vue&type=script&lang=js"
export * from "./intantTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./intantTaskDetail.vue?vue&type=style&index=0&id=b4a87ef4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports